import { Card, CardContent, Typography } from '@mui/material'
import ReactECharts from 'echarts-for-react'

interface DevicesChartProps {
    data: Array<{ device: string; visitors: number }>
    title?: string
}

const DEVICE_COLORS: Record<string, string> = {
    desktop: '#6366f1',
    mobile: '#ec4899',
    tablet: '#f59e0b',
    bot: '#94a3b8',
    unknown: '#cbd5e1',
}

export function DevicesChart({ data, title = 'Devices' }: DevicesChartProps) {
    const option = {
        tooltip: { trigger: 'item' as const },
        legend: { bottom: 0 },
        series: [
            {
                type: 'pie' as const,
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
                label: { show: false },
                emphasis: { label: { show: true, fontSize: 14, fontWeight: 'bold' as const } },
                data: data.map(d => ({
                    name: d.device.charAt(0).toUpperCase() + d.device.slice(1),
                    value: d.visitors,
                    itemStyle: { color: DEVICE_COLORS[d.device] ?? '#94a3b8' },
                })),
            },
        ],
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {title}
                </Typography>
                {data.length > 0 ? (
                    <ReactECharts option={option} style={{ height: 300 }} />
                ) : (
                    <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
                        No device data yet
                    </Typography>
                )}
            </CardContent>
        </Card>
    )
}
